export default {"src":"/_next/static/media/close-red.c1c72b1d.svg","height":16,"width":16};